import { render, staticRenderFns } from "./gs-button-group.vue?vue&type=template&id=a4801482&scoped=true&"
import script from "./gs-button-group.vue?vue&type=script&lang=ts&"
export * from "./gs-button-group.vue?vue&type=script&lang=ts&"
import style0 from "./gs-button-group.vue?vue&type=style&index=0&id=a4801482&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4801482",
  null
  
)

export default component.exports